import PropTypes from 'prop-types';
import React from 'react';
import * as THREE from 'three'
import { Canvas, useThree } from '@react-three/fiber';
import { OrbitControls, AdaptiveDpr, AdaptiveEvents} from '@react-three/drei';

export default function BaseCanvas ({
    frameloop = "demand",
    position = [0, 0, 5],
    autoRotate = false,
    minDistance,
    maxDistance,
    minAzimuthAngle,
    maxAzimuthAngle,
    minPolarAngle,
    maxPolarAngle,
    children,
}) {

    const aspect = window.innerWidth/ window.innerHeight;
    //const { renderer } = useThree();
    //renderer.setSize( window.innerWidth/2, window.innerHeight/2 );

    return (
        <Canvas
            frameloop={frameloop}
            mode="concurrent"
            performance={{
                current: 1,
                min: 0.1,
                max: 1,
                debounce: 200,
                //regress: () => void,
            }}
            camera={{ position: position, aspect: aspect, near: 1, far: 200, fov: 35} }
            style={{height: 900, position: 'unset'}}
        >
            <AdaptiveDpr pixelated />
            <AdaptiveEvents />

            <hemisphereLight skyGround='#3FB950' groundColor='#f9f9f9' intensity='2' />

            { children } 

            <OrbitControls
                autoRotate={autoRotate}
                minPolarAngle={minPolarAngle}
                maxPolarAngle={maxPolarAngle}
                minDistance={minDistance}
                maxDistance={maxDistance}
                minAzimuthAngle={minAzimuthAngle}
                maxAzimuthAngle={maxAzimuthAngle}
                target={new THREE.Vector3(0,0,0)}
            />
        </Canvas>
    );
};
